// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Layer {
    constructor(newCanvas) {
        this.canvas = newCanvas;
        this.context = newCanvas.getContext('2d');
        this.isDirty = true;
    }
}
